module.exports = __webpack_public_path__ + "assets/img/logo.e772cea5.svg";